import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";

const CTA = () => {
  const { user, subscription } = useAuth();
  const navigate = useNavigate();
  const isPremium = subscription?.subscribed;

  const handleStartTrial = () => {
    if (user) {
      navigate('/pricing');
    } else {
      navigate('/auth');
    }
  };

  return (
    <section className="py-20 relative overflow-hidden bg-secondary/20">
      <div className="absolute inset-0 bg-gradient-opal opacity-10" />
      
      <div className="container px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center space-y-8">
          {!isPremium && (
            <>
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-primary rounded-full mb-4">
                <span className="text-sm font-bold">🚀 Join the Elite Trading Revolution</span>
              </div>
              
              <h2 className="text-4xl md:text-6xl font-bold leading-tight">
                Transform Your Trading,<br />
                <span className="bg-gradient-primary bg-clip-text text-transparent">Start Winning Today</span>
              </h2>
              
              <p className="text-xl md:text-2xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Get elite signals unified in one powerful platform. Your path to consistent profits starts here.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
                <Button 
                  size="lg" 
                  className="bg-gradient-primary hover:shadow-glow-primary transition-all duration-300 text-lg px-12 py-6 group"
                  onClick={handleStartTrial}
                >
                  {user ? "Get Premium — Start Free Trial" : "Sign Up — Start Free Trial"}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </Button>
                
                <Button 
                  size="lg" 
                  variant="outline"
                  className="text-lg px-12 py-6 border-primary/50 hover:bg-primary/10"
                  asChild
                >
                  <a href="/community" className="flex items-center gap-2">
                    Join Our Community — Free
                  </a>
                </Button>
              </div>

              <div className="pt-8 flex flex-wrap justify-center gap-4 text-sm">
                <div className="flex items-center gap-2 px-4 py-2 bg-card/50 rounded-full">
                  <span className="text-primary">✓</span>
                  <span>7-Day Free Trial</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-card/50 rounded-full">
                  <span className="text-primary">✓</span>
                  <span>No Credit Card Required</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 bg-card/50 rounded-full">
                  <span className="text-primary">✓</span>
                  <span>Cancel Anytime</span>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTA;